/**
 * Stable CSS class names for E2E — StoreLcwaikikiV2 page.
 * Used by the test automation team as deterministic selectors.
 * Containers use `store-lcwaikiki-v2__<element>`; inputs and user-interactable
 * controls use `store-lcwaikiki-v2-input--<name>`.
 */
export const SLV2 = {
    page: 'store-lcwaikiki-v2-page',
    root: 'store-lcwaikiki-v2',

    breadcrumb: 'store-lcwaikiki-v2__breadcrumb',
    searchForm: 'store-lcwaikiki-v2__search-form',
    searchBox: 'store-lcwaikiki-v2__search-box',
    inputOrderNo: 'store-lcwaikiki-v2-input--order-no',
    btnSearch: 'store-lcwaikiki-v2-input--button-search',
    loading: 'store-lcwaikiki-v2__loading',

    results: 'store-lcwaikiki-v2__results',
    resultsGrid: 'store-lcwaikiki-v2__results-grid',
    billStack: 'store-lcwaikiki-v2__bill-stack',
    billPanel: 'store-lcwaikiki-v2__bill-panel',
    billHeader: 'store-lcwaikiki-v2__bill-header',
    billShippingInfo: 'store-lcwaikiki-v2__bill-shipping-info',
    billShippingIcon: 'store-lcwaikiki-v2__bill-shipping-icon',
    billShippingLabel: 'store-lcwaikiki-v2__bill-shipping-label',
    billShippingLink: 'store-lcwaikiki-v2-input--shipping-link',
    billCopyButtonBox: 'store-lcwaikiki-v2__bill-copy-button-box',
    btnDownloadInvoice: 'store-lcwaikiki-v2-input--button-download-invoice',
    billItemsGrid: 'store-lcwaikiki-v2__bill-items-grid',
    emptyState: 'store-lcwaikiki-v2__empty-state',

    cellProductImage: 'store-lcwaikiki-v2__cell-product-image',
    cellProductImageLink: 'store-lcwaikiki-v2-input--cell-product-image-link',
    cellProductInfo: 'store-lcwaikiki-v2__cell-product-info',
    cellProductTitle: 'store-lcwaikiki-v2__cell-product-title',
    cellProductChips: 'store-lcwaikiki-v2__cell-product-chips',
    cellProductCodeChip: 'store-lcwaikiki-v2__cell-product-code-chip',
    cellProductColorChip: 'store-lcwaikiki-v2__cell-product-color-chip',
    cellProductSizeChip: 'store-lcwaikiki-v2__cell-product-size-chip',
    cellProductBrandChip: 'store-lcwaikiki-v2__cell-product-brand-chip',
    cellQuantity: 'store-lcwaikiki-v2__cell-quantity',
    cellUnitPrice: 'store-lcwaikiki-v2__cell-unit-price',
    cellSalePrice: 'store-lcwaikiki-v2__cell-sale-price',
} as const;

export const slv2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
